module.exports = __webpack_public_path__ + "static/media/66f24f2d.jpg";